export default __webpack_public_path__ + "static/media/walking_woman.ad28c139.svg";